module.exports = __webpack_public_path__ + "img/TR.7f02f89c.svg";